import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import type { UpgradePreview } from "@/react/types/Paywalls/Checkout/UpgradePreview";

import { UpgradeCurrentPlanSkeleton } from "./UpgradeLoadingSkeletons";
import { UpgradeTargetTrialBadge } from "./UpgradeTargetTrialBadge";

const i18nRoot = "paywall_checkout.offer_page.upgrade";

export const UpgradeCurrentPlanCard = ({
  isLoading,
  showBilledCadence,
  source,
}: {
  isLoading: boolean;
  showBilledCadence: boolean;
  source?: UpgradePreview["source"];
}) => (
  <section
    className="rounded-t-xl border border-b-0 border-primary bg-secondary p-4"
    data-testid="upgrade-current-plan-card"
  >
    <div className="flex items-center justify-between gap-3">
      <Typography variant="label-sm" color="secondary">
        {t([i18nRoot, "current_plan"])}
      </Typography>
      {source && source.trial_days > 0 && (
        <UpgradeTargetTrialBadge
          days={source.trial_days}
          testId="upgrade-host-trial-badge"
          variant="secondary"
        />
      )}
    </div>
    {isLoading && <UpgradeCurrentPlanSkeleton />}
    {source && (
      <>
        <div className="mt-1 flex items-center justify-between gap-3">
          <Typography variant="heading-md">{source.name}</Typography>
          <Typography
            className="inline-flex items-baseline gap-1"
            variant="body-md"
          >
            <strong>{source.display_amount}</strong>
            <span className="text-light">
              {t([i18nRoot, "term_units", source.interval_type])}
            </span>
          </Typography>
        </div>
        {showBilledCadence && (
          <Typography className="mt-1" variant="body-sm" color="secondary">
            {source.billing_label}
          </Typography>
        )}
      </>
    )}
  </section>
);
